import moment from 'moment';

const pipelineAutoPopulate = ({
  firstName,
  lastName,
  pipeline,
  inspectionLastDate,
  intervalId,
  userId
}) => {
  return {
    User: {
      //SourceProperty,
      InspectorName: `${firstName} ${lastName}`,
      Id: userId
    },
    Incident: {
      InitiatorName: `${firstName} ${lastName}`
    },
    InspectionSchedules: {
      IntervalId: intervalId
    },
    Pipeline: {
      FromLocation: pipeline?.fromLocation || null,
      LicenseNumber: pipeline?.licenseNumber || null,
      PipelineNumber: pipeline?.pipelineNumber || null,
      Status: pipeline?.status || null,
      ToLocation: pipeline?.toLocation || null,
      Area: pipeline?.area || null,
      AssignedBatchingIntervalId: pipeline?.assignedBatchingIntervalId || null,
      AssignedPiggingIntervalId: pipeline?.assignedPiggingIntervalId || null,
      CathodicProtectionId: pipeline?.cathodicProtectionId || null,
      ExternalProtection: pipeline?.externalProtection || null,
      InternalProtection: pipeline?.internalProtection || null,
      Material: pipeline?.material || null,
      OperationsAreaId: pipeline?.operationsAreaId || null,
      ReceiverTypeId: pipeline?.receiverTypeId || null,
      SenderTypeId: pipeline?.senderTypeId || null,
      Substance: pipeline?.substance || null,
      PipelineTypeId: pipeline?.pipelineTypeId || null,
      MaintenanceComments: pipeline?.maintenanceComments || null,
      GDM_ID: pipeline?.gdmId || null,
      Insulated: pipeline?.insulated || false,
      LineNumber: pipeline?.lineNumber || null,
      WaterCrossing: pipeline?.waterCrossing || null,
      PipelineKey: pipeline?.pipelineKey || null,
      PastLicenseLine: pipeline?.pastLicenseLine || null,
      LastInspectionDate: inspectionLastDate[pipeline?.pipelineId]?.inspectionDate
        ? moment(inspectionLastDate[pipeline?.pipelineId]?.inspectionDate)
            .format('YYYY-MM-DD')
            ?.toString()
        : null,

      SenderLocation: pipeline?.senderLocation || null,
      ReceiverLocation: pipeline?.receiverLocation || null,
      // H2SConcentration: pipeline?.h2SConcentrationMeasurement || null, // h2SConcentration
      H2SConcentration: {
        textBoxValue: pipeline?.h2SConcentration || null,
        textBoxUnitValue: pipeline?.h2SConcentrationMeasurement || null
      },
      // Length: pipeline?.lengthMeasurement || null, // length,
      // OutsideDiameter: pipeline?.outsideDiameterMeasurement || null, //outsideDiameter
      // RiserDiameter: pipeline?.riserDiameterMeasurement || null,
      RiserDiameter: {
        textBoxValue: pipeline?.riserDiameter || null,
        textBoxUnitValue: pipeline?.riserDiameterMeasurement || null
      },
      // RiserWallThickness: pipeline?.riserWallThicknessMeasurement || null, // wallThickness
      RiserWallThickness: {
        textBoxValue: pipeline?.riserWallThickness || null,
        textBoxUnitValue: pipeline?.riserWallThicknessMeasurement || null
      },

      // WallThickness: pipeline?.wallThicknessMeasurement || null,

      WallThickness: {
        textBoxValue: pipeline?.wallThickness || null,
        textBoxUnitValue: pipeline?.wallThicknessMeasurement || null
      },

      // MaxOperatingPressure: pipeline?.maxOperatingPressureMeasurement || null, // maxOperatingPressure,
      MaxOperatingPressure: {
        textBoxValue: pipeline?.maxOperatingPressure || null,
        textBoxUnitValue: pipeline?.maxOperatingPressureMeasurement || null
      },
      Length: {
        textBoxValue: pipeline?.length || null,
        textBoxUnitValue: pipeline?.lengthMeasurement || null
      },
      InsideDiameter: {
        textBoxValue: pipeline?.insideDiameter || null,
        textBoxUnitValue: pipeline?.insideDiameterMeasurement || null
      },
      OutsideDiameter: {
        textBoxValue: pipeline?.outsideDiameter || null,
        textBoxUnitValue: pipeline?.outsideDiameterMeasurement || null
      },
      PigRunLength: {
        textBoxValue: pipeline?.pigRunLength || null,
        textBoxUnitValue: pipeline?.pigRunLengthMeasurement || null
      }
    }
  };
};

export default pipelineAutoPopulate;
